export default {
    home_page_title: "帳號資料",
    security_page_title: "安全中心",
    security_setting_page_title: "安全中心",
    security_phone_label: "手機",
    security_email_label: "電子信箱",
    security_question_label: "安全問題",
    security_unset_text: "未設定",
    security_setted_text: "Set",
    security_question_options: [
        "您母親的姓名是?",
        "您配偶的生日是?",
        "您父親的姓名是?",
        "您的學號（或工號）是?",
        "您最熟悉的童年好友名字是?",
        "對您影響最大的人名字是?"
    ],
    password_lost_page_title: "忘記密碼",
    password_reset_page_title: "重置密碼",
    password_lost_account_placeholder: "輸入忘記密碼的帳號",
    empty_lost_account_tips: "用戶名不能為空",
    iscorrect_lost_account_tips: "User does not exist",
    password_reset_new_placeholder: "新密碼",
    password_reset_confirm_placeholder: "確認新密碼",
    password_verify_page_title: "驗證身份",
    phone_verify_page_title: "驗證身份",
    email_verify_page_title: "驗證身份",
    question_verify_page_title: "驗證身份",
    phone_reset_page_title: "手機",
    email_reset_page_title: "電子信箱",
    question_reset_page_title: "安全問題",
    phone_binding_text: "您綁定的手機號為",
    email_binding_text: "您綁定的電子信箱為",
    verification_code_text: "驗證碼",
    resend_text: "重新發送",
    empty_phone_number_tips: "請輸入手機號",
    iscorrect_phone_number_tips: "Please enter a valid phone number",
    empty_verification_code_tips: "請輸入驗證碼",
    iscorrect_verification_code_tips: "驗證碼錯誤",
    password_placeholder: "密碼",
    empty_password_tips: "請輸入密碼",
    iscorrect_password_tips: "密碼錯誤",
    mismatched_rule_password_tips: "密碼不能包含&、#、空格",
    different_confirm_password_tips: "密碼不一致",
    empty_email_tips: "請輸入電子信箱",
    iscorrect_email_tips: "電子信箱錯誤",
    answer_placeholder: "答案",
    empty_question_tips: "Choose a security question",
    empty_answer_tips: "Give your answer here",
    iscorrect_answer_tips: "Wrong answer",
    next_step_text: "下一步",
    submit_text: "Submit",
    submit_success_tips: "Success",
    submit_error_tips: "Operation failed, please try again",
    get_data_fail_tips: "網路異常，請稍後再試",
    use_other_verification_type_text: "以其他方式驗證",
    custom_support_notice:
        "該帳號未設定密保管道，您可以通過在PC端打開下方連結進行申訴." +
        process.env.VUE_APP_ORIGIN_PROFILE
};
